import { render, staticRenderFns } from "./AppSubmenu.vue?vue&type=template&id=83b23ba0&scoped=true&"
import script from "./AppSubmenu.vue?vue&type=script&lang=js&"
export * from "./AppSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b23ba0",
  null
  
)

export default component.exports